<template>
  <div :class="$style.container">
    <slot />
  </div>
</template>

<style lang="scss" module src="./Wysiwyg.scss" />
